import {Search} from 'history';
import {dateFromString, toUTCWithLocalTime} from '~/lib/date';
import {PerformanceType} from '~/modules/Dashboard/models/Performance';
import {IPerformanceQuery} from '~/modules/Dashboard/reducer';

enum QueryParams {
    CHART_VIEW = 'v',
    FROM = 'f',
    TO = 't',
    DIMENSIONS = 'd',
    PERFORMANCE_TYPE = 'p'
}

const dateToSearch = (date: Date): string => toUTCWithLocalTime(date)!.toISOString();

export const fromSearch = (search: Search, defaultQuery: IPerformanceQuery): IPerformanceQuery => {
    const params = new URLSearchParams(search);

    if (params.has(QueryParams.PERFORMANCE_TYPE)) {
        defaultQuery.performanceType = params.get(QueryParams.PERFORMANCE_TYPE) as PerformanceType;
    }
    if (params.has(QueryParams.FROM)) {
        defaultQuery.from = dateFromString(params.get(QueryParams.FROM));
    }
    if (params.has(QueryParams.FROM)) {
        defaultQuery.to = dateFromString(params.get(QueryParams.TO));
    }
    if (params.has(QueryParams.FROM)) {
        defaultQuery.dimensions = params.getAll(QueryParams.DIMENSIONS);
    }
    if (params.has(QueryParams.FROM)) {
        defaultQuery.chartType = params.get(QueryParams.CHART_VIEW) as any;
    }
    return defaultQuery;
};

export const toSearch = (query: IPerformanceQuery): Search => {
    const params = new URLSearchParams();
    if (query.performanceType) {
        params.set(QueryParams.PERFORMANCE_TYPE, query.performanceType);
    }
    if (query.from) {
        params.set(QueryParams.FROM, dateToSearch(query.from));
    }
    if (query.to) {
        params.set(QueryParams.TO, dateToSearch(query.to));
    }
    if (query.chartType) {
        params.set(QueryParams.CHART_VIEW, query.chartType.toString());
    }
    if (query.dimensions) {
        query.dimensions.forEach(dimension => params.append(QueryParams.DIMENSIONS, dimension));
    }
    return params.toString();
};
